import axios from 'axios'

export const httpAxios = axios.create({
    headers: {
        'Content-Type': 'application/json',
    }
});